import { render, staticRenderFns } from "./cv-row.vue?vue&type=template&id=71d9257c&"
import script from "./cv-row.vue?vue&type=script&lang=js&"
export * from "./cv-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports